/* Draft restoration is a transaction: prepare state, render once, baseline, unlock. */
(() => {
  const clone = value => JSON.parse(JSON.stringify(value));
  const key = step => String(typeof step === 'string' ? step : step?.step || '').toLowerCase();
  const categories = { fotos_estampas: 'stamps', foto_rompecabezas: 'puzzle', fotos_con_texto: 'text_photos', fotos_fondo: 'backgrounds' };
  const defaults = { portada: { diseno: null, frase: '', nombres: '', fecha: '' }, dedicatoria: { deParteDe: '' },
    texto_final: { texto: '' }, spotify_playlist: { link: '' }, peliculas: { items: [] }, sopa_letras: { items: [] },
    fecha_especial: { value: '' }, spotify_codigos: { canciones: [] } };

  const conflictKey = () => 'tac:draft-conflict:v1:' + window.tacDraftClient.session.id;
  function preserveConflict() {
    const client = window.tacDraftClient;
    client.conflictSnapshot = { draft_id: client.session.id, revision: client.session.revision,
      current_step_key: client.currentStepKey, configuration: tacDraftBuildConfiguration() };
    // Only text/options and remote metadata, never the session or its bearer token.
    try { sessionStorage.setItem(conflictKey(), JSON.stringify(client.conflictSnapshot)); } catch (_) {}
    showConflict();
  }
  function showConflict() {
    const client = window.tacDraftClient;
    if (!client.conflictSnapshot) {
      try { client.conflictSnapshot = JSON.parse(sessionStorage.getItem(conflictKey()) || 'null'); } catch (_) {}
    }
    const hub = document.getElementById('customizer-hub');
    if (!hub || !client.conflictSnapshot || document.getElementById('tac-draft-conflict')) return;
    const notice = document.createElement('div'); notice.id = 'tac-draft-conflict'; notice.setAttribute('role', 'status');
    notice.style.cssText = 'position:sticky;top:0;z-index:10;background:#fff4df;padding:12px;color:#222';
    const message = document.createElement('p'); message.textContent = window.t('draft_conflict_message');
    const download = document.createElement('button'); download.type = 'button'; download.textContent = window.t('draft_conflict_copy');
    download.onclick = () => {
      const url = URL.createObjectURL(new Blob([JSON.stringify(client.conflictSnapshot, null, 2)], { type: 'application/json' }));
      const link = document.createElement('a'); link.href = url; link.download = 'album-cambios-pendientes.json'; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    };
    notice.append(message, download); hub.prepend(notice);
  }
  for (const [lang, entries] of Object.entries({
    es: { draft_conflict_message: 'Hay cambios de otra pestaña. Tus cambios pendientes se conservan en esta pestaña. Puedes guardar una copia y recargar para abrir la versión guardada.', draft_conflict_copy: 'Guardar copia de mis cambios' },
    en: { draft_conflict_message: 'Another tab has newer changes. Your pending changes are kept in this tab. You can save a copy and reload to open the saved version.', draft_conflict_copy: 'Save a copy of my changes' }
  })) { window.tacCopy ||= {}; window.tacCopy[lang] ||= {}; Object.assign(window.tacCopy[lang], entries); }

  function restore(configuration, product, records) {
    if (configuration.product_handle && configuration.product_handle !== product.handle) throw new Error('draft_product_mismatch');
    if (configuration.schema_version && configuration.schema_version !== 1) throw new Error('draft_schema_unsupported');
    const data = clone(configuration.data || {});
    for (const [name, values] of Object.entries(defaults)) data[name] = { ...clone(values), ...data[name] };
    data.pricing = window.TACStepFlow.normalizePricing(clone(configuration.pricing || {}));
    const saved = configuration.flow?.active_steps;
    const steps = clone(Array.isArray(saved) && saved.length ? saved : product.steps);
    // Old drafts may contain pricing choices but no expanded flow yet.
    for (let i = 0; i < steps.length; i++) {
      if (typeof steps[i] === 'string') steps[i] = { step: steps[i] };
      const step = steps[i];
      if (key(step) === 'fotos_estampas' && step.dynamic_options && !step.dynamic_options.selected_by_user && data.pricing.fotos_qty != null) {
        const quantity = Number(data.pricing.fotos_qty);
        if (!(step.dynamic_options.allowed_values || []).includes(quantity)) throw new Error('draft_quantity_unsupported');
        step.cantidad = quantity; step.dynamic_options.selected_by_user = quantity;
      }
      if (step.conditional_step && (step.enabled_by_user === true || (step.enabled_by_user == null && data.pricing.extras?.[key(step)]))) {
        step.enabled_by_user = true;
        if (!steps.some(s => key(s) === key(step.conditional_step))) {
          steps.splice(i + 1, 0, { ...clone(step.conditional_step), _tacConditionalFor: key(step) });
        }
      }
    }
    const normalize = file => ({ ...clone(file), id: file.id || file.file_id, file_id: file.id || file.file_id, position: Number(file.position) });
    const unique = new Set();
    for (const file of records) {
      const slot = file.category + ':' + file.position;
      if (!Number.isInteger(Number(file.position)) || Number(file.position) < 1 || Number(file.position) > 500 || unique.has(slot)) throw new Error('draft_invalid_file_slots');
      unique.add(slot);
    }
    const cover = records.find(f => f.category === 'cover' && Number(f.position) === 1);
    const coverReconciliationPending = cover?.reconciliation === 'reconciliation_pending';
    Object.assign(data.portada, { fotoFile: null, fotoPreviewURL: '', fotoRemote: cover ? normalize(cover) : null,
      fotoUploadStatus: cover?.status === 'verified' && !coverReconciliationPending ? 'verified' : (cover ? 'failed' : 'idle'),
      fotoUploadError: cover?.reconciliation === 'replacement_reselect_required' ? 'replacement_reselect' : (coverReconciliationPending || (cover && cover.status !== 'verified') ? 'reselect' : null) });
    for (const [name, category] of Object.entries(categories)) {
      const state = data[name] ||= {};
      const files = records.filter(f => f.category === category);
      const step = steps.find(s => key(s) === name);
      const n = Math.max(Number(step?.cantidad || (category === 'puzzle' ? 1 : 0)), ...files.map(f => Number(f.position)), state.textos?.length || 0);
      state.expected = n;
      state.files = Array(n).fill(null); state.previewFiles = Array(n).fill(null); state.urls = Array(n).fill('');
      state.remotes = Array(n).fill(null); state.uploadStatus = Array(n).fill('idle'); state.errors = Array(n).fill(null);
      for (const file of files) {
        const i = Number(file.position) - 1;
        state.remotes[i] = normalize(file);
        const unresolvedReplacement = file.reconciliation === 'reconciliation_pending';
        state.uploadStatus[i] = file.status === 'verified' && !unresolvedReplacement ? 'verified' : 'failed';
        if (file.reconciliation === 'replacement_reselect_required') state.errors[i] = 'replacement_reselect';
        else if (file.status !== 'verified' || unresolvedReplacement) state.errors[i] = 'reselect';
      }
      if (category === 'text_photos') state.textos = Array.from({ length: n }, (_, i) => String(state.textos?.[i] ?? ''));
    }
    return { data, steps };
  }

  async function prepare(product) {
    const client = window.tacDraftClient;
    if (client.hydrationReady && client.hydratedDraftId === client.session?.id) return window.tacCustomizer;
    if (client.hydrationPromise) return client.hydrationPromise;
    client.hydrationReady = false;
    clearTimeout(client.saveTimer); clearTimeout(client.retryTimer);
    client.hydrationPromise = (async () => {
      const session = await tacEnsureDraftSession();
      const authoritativeProduct = window.TACProductExperience?.adaptProduct?.(
        product,
        client.experience,
        window
      ) || product;
      const listedRecords = await tacDraftListFiles(session);
      const records = typeof tacDraftReconcileRemoteFiles === 'function'
        ? await tacDraftReconcileRemoteFiles(session, listedRecords)
        : listedRecords;
      const restored = restore(client.serverConfiguration || {}, authoritativeProduct, records);
      window.tacCustomizer ||= {};
      window.tacCustomizer.data = restored.data;
      window.tacCustomizer.activeSteps = restored.steps;
      client.runtimeProduct = authoritativeProduct;
      client.hydratedDraftId = session.id;
      return window.tacCustomizer;
    })();
    try { return await client.hydrationPromise; }
    finally { client.hydrationPromise = null; }
  }

  function finish() {
    const client = window.tacDraftClient;
    if (client.hydrationReady) return;
    if (!client.session || client.hydratedDraftId !== client.session.id) throw new Error('draft_not_hydrated');
    client.lastSavedFingerprint = JSON.stringify({ current_step_key: client.currentStepKey, configuration: tacDraftBuildConfiguration() });
    client.hydrationReady = true;
    tacDraftSetSaveState('clean');
    if (client.wasRestored && typeof document.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
      document.dispatchEvent(new CustomEvent('tac:draft-restored', { detail: { draft_id: client.session.id } }));
    }
    showConflict();
  }
  window.TACHydration = { restore, prepare, finish, preserveConflict };
})();
